import { render } from "./OrderReceivedView.vue?vue&type=template&id=62b15ad0&ts=true"
import script from "./OrderReceivedView.vue?vue&type=script&lang=ts"
export * from "./OrderReceivedView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__